import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import '../../css/Photos.css'
import Table from '../../components/common/CustomTable';
import Button from '../../components/common/ui/Button';
import ScrollContainer from '../../components/common/ScrollContainer';
import Loader from '../../components/common/Loader';
import CustomModal from '../../components/common/CustomModal ';
import { E_CardActions, KioskDashboardActions } from '../../_store';
import TranslateFile from '../../Loc/TranslateFile';
import Send_E_Card from './Send_E_Card';
import CustomPhoto from '../../components/common/CustomPhoto';
import { showAlert } from '../../components/common/showAlert';
import { inboxActions } from '../../_store/inbox.slice';
import { MyContactsActions } from '../../_store/MyContacts.slice';
import useKioskRestrictIntervalValidation from '../../hooks/useKioskRestrictIntervalValidation';
import CustomKeyboard from '../../components/common/CustomKeyboard';
import { getStoredValue } from "../../_helpers/storageHelper";
import closeIcon from "../../assets/close-icon.svg";
import quickicon from "../../assets/quickmenu.svg";
import CustomEcard from '../../components/common/CustomEcard';

const E_Card = () => {

    const [LoadECardSearchDetails, setLoadECardSearchDetails] = React.useState([]);
    const dispatch = useDispatch();
    const loginResponse = useSelector(state => state.kioskLogin.loginResponse);
    const storedloginResponse = loginResponse || getStoredValue("loginResponse");
    const [isshowListPage, setisshowListPage] = React.useState(true);
    const [selectItem, setselectItem] = React.useState();
    const [rotation, setRotation] = useState(0);
    const loginDetails = useSelector(state => state.kioskLogin.loginDetails);
    const storedLoginDetails = getStoredValue("loginDetails") || loginDetails;
    const [imgsrc, setimgsrc] = useState();
    const [loading, setLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const currentLang = TranslateFile();
    const [currentPage, setcurrentPage] = React.useState(1);
    const [rowPerPage, setrowPerPage] = React.useState(10);
    const [formData, setFormData] = useState({
        user: '', subject: '', freeCredits: 0.00, userCredits: 0.00, ecardCost: 0.00, freeCreditStatus: false,
        activeTab: "E_Card", facilityEmojiCost: 0.00, balance: 0.00, showTotalMessageCost: false, isEard: true,
        pageNo: 1, rowCountPerPage: 8, totalMessageCost: 0.00, isUserdisabled: false, search: ""
    });
    const [isConnectionCancelled, setisConnectionCancelled] = useState(false);
    const [modalContent, setModalContent] = useState();
    const [modalContentColor, setmodalContentColor] = useState();
    const { MyContactsDisplayForEcardDetails } = useSelector(state => state.E_Card);
    const validateKioskRestrictInterval = useKioskRestrictIntervalValidation();
    const [showBoard, setShowBoard] = useState(false);
    const [isprevsearchvalue, setisprevsearchvalue] = useState();
    const { isPageReload: isPageReloading, isSignalRData } = useSelector((state) => state.auth);
    const [isMenuActive, setMenuActive] = useState(false);
    const [customized, setCustomized] = useState(false);
    const [envelopecolor, setenvelopecolor] = useState("");
    const [ecardbgcolor, setecardbgcolor] = useState("");
    const [rippencolor, setrippencolor] = useState("");

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        }).format(date)
            .replace(',', '');
    };

    const columns = [
        {
            name: currentLang?.TableHeaders.Subject, width: '330px', selector: (row) => row.EcardSubject, sortable: true,
            cell: (row) => (
                <div className="d-flex " onClick={() => handleONCLick(row)}>
                    <div>
                        {row.EcardSubject}
                    </div>
                    {(row.Sender === "Public User" && row.ReadStaus == "Unread") && (
                        <div class="newbutton-container ms-2">
                            {currentLang?.E_Cards?.New}
                            <div class="border-animation"></div>
                        </div>
                    )}
                </div>
            ),
            sortFunction: (a, b) => a.EcardSubject.toLowerCase().localeCompare(b.EcardSubject.toLowerCase())
        },
        {
            name: currentLang?.TableHeaders.From, selector: (row) => row.MessageFrom, sortable: true,
            sortFunction: (a, b) => a.MessageFrom.toLowerCase().localeCompare(b.MessageFrom.toLowerCase()),
            cell: (row) => (
                <div className="d-flex   align-items-center" onClick={() => { handleONCLick(row) }}>
                    <div className={row?.Sender == "Inmate" ? "user-batch button-primary me-1" : "user-batch button-success me-1"}></div>
                    <div className='me-2'>
                        {row.MessageFrom}
                    </div>
                </div>
            ),
        },
        {
            name: currentLang?.TableHeaders?.To, selector: (row) => row.MessageTo, sortable: true,
            sortFunction: (a, b) => a.MessageTo.toLowerCase().localeCompare(b.MessageTo.toLowerCase()),
            cell: (row) => (
                <div className="d-flex align-items-center" onClick={() => { handleONCLick(row) }}>
                    <div className={row?.Sender !== "Inmate" ? "user-batch button-primary me-1" : "user-batch button-success me-1"}></div>
                    <div className='me-2'>
                        {row.MessageTo}
                    </div>
                </div>
            ),
        },
        {
            name: currentLang?.TableHeaders?.Date_Time, width: '200px', selector: (row) => formatDate(row.DebitAmountDate), sortable: true,
            sortFunction: (a, b) => new Date(a.DebitAmountDate) - new Date(b.DebitAmountDate),
        },
        {
            name: currentLang?.TableHeaders?.Status, width: '120px', selector: (row) => row.ReadStaus, sortable: true,
            cell: (row) => (
                <div className="d-flex " title={row.ReadStaus} onClick={() => { handleONCLick(row) }}>
                    {PhotoReadStatus(row.ReadStaus)}
                </div>
            ),
        },
    ];

    const PhotoReadStatus = (status) => {
        return <span className={`${status == "Unread" ? 'StatusPatch-danger' : 'StatusSent'}`}>{status}</span>;
    };

    useEffect(() => {
        validateKioskRestrictInterval(storedLoginDetails)
    }, []);

    useEffect(() => {
        PageOnLoad(currentPage, rowPerPage);
        setisshowListPage(true); setFormData(prevFormData => ({
            ...prevFormData,
            activeTab: "E_Card",
        }));
        handleLoadFreeCredits();
    }, [currentPage, rowPerPage, loginResponse, isPageReloading]);

    // Handle page change
    const handlePageChange = (page) => {
        setcurrentPage(page);
    };

    // Handle rows per page change
    const handleonChangeRowsPerPage = (rowsPerPage) => {
        setrowPerPage(rowsPerPage);
    }

    const PageOnLoad = (pageNo, rowCountPerPage) => {
        setLoading(true);
        var Objectdata = {
            publicUserID: 0, sortField: "", ecardSubject: '', fromDate: '', toDate: '', status: 0,
            pageNo: pageNo, rowCountPerPage: rowCountPerPage, inmateID: storedloginResponse?.InmateID, MessageFrom: formData?.search
        };
        dispatch(E_CardActions.getLoadE_CardList(Objectdata)).then(x => {
            setLoadECardSearchDetails(x?.payload || []);
            setLoading(false);
        });
    }

    useEffect(() => {
        switch (isSignalRData?.type) {
            // case 'Send_ECard':
            //     var Objectdata = {
            //         publicUserID: 0, sortField: "", ecardSubject: '', fromDate: '', toDate: '', status: 0,
            //         pageNo: currentPage, rowCountPerPage: rowPerPage, inmateID: storedloginResponse?.InmateID, MessageFrom: formData?.search
            //     };
            //     dispatch(E_CardActions.getLoadE_CardList(Objectdata)).then(x => {
            //         setLoadECardSearchDetails(x?.payload || []);
            //         setLoading(false);
            //     });
            //     break;
            case 'Read_Ecard':
                const updatedEcards = LoadECardSearchDetails?.map(card => {
                    if (card?.CardId === isSignalRData?.message) {
                        return { ...card, ReadStaus: "Read" };
                    }
                    return card;
                });
                setLoadECardSearchDetails(updatedEcards);
                break;
        }
    }, [isSignalRData])

    const handleBack = () => {
        setisshowListPage(true);
        if (formData?.activeTab === 'E_Card') {
            PageOnLoad(currentPage, rowPerPage);
        }
        else {
            setFormData(prevFormData => ({
                ...prevFormData, activeTab: prevFormData?.activeTab, subject: "", user: "", isUserdisabled: false
            }))
        }
    }

    const handleONCLick = async (item) => {
        setLoading(true);
        setRotation(0);
        const result = item; setLoading(false);
        if (result?.EcardBase64 || result?.EcardFilePath || (item?.EcardFilePath?.startsWith("https"))) {
            setisshowListPage(false);
            setselectItem(item);
            if (result?.EcardBase64) {
                setimgsrc(`data:image/png;base64,${result?.EcardBase64}`);
            } else if (item?.EcardFilePath?.startsWith("https")) {
                setimgsrc(item?.EcardFilePath);
            } else {
                setimgsrc(`${process.env.REACT_APP_API_IMAGE_URL}${result?.EcardFilePath}`);
            }
        } else {
            setModalContent(currentLang?.AlertPopup?.ECard_Rejected_by_Administrator);
            setmodalContentColor('#c8605e');
            setShowPopup(true);
        }

        if (item?.ReadStaus == "Unread" && item?.Sender !== "Inmate") {
            dispatch(E_CardActions.loadInsertUpdateUspInmateInboxECardRead({ eCardId: item?.CardId, inmateId: item?.InmateId, PublicUserId: item?.PublicUserId })).then(x => {
                handleloadsidemenu();
            })
        }
    }

    const handleloadsidemenu = () => {
        const podCode = storedLoginDetails?.PodCode;
        const inmateID = storedloginResponse?.InmateID;
        if (inmateID && podCode)
            dispatch(KioskDashboardActions.getLoadInmateMainMenu({ inmateID, podCode }));
    }

    // Cancel Request
    const UpdateConnectionConfiramation = (selectedrow) => {
        showAlert(
            null,
            currentLang?.AlertPopup?.Message,
            currentLang?.AlertPopup?.Cancel_Confirm,
            "question",
            "700px",
            currentLang?.Buttons?.Yes,
            null, // Default redirect URL
            null,  // Redux dispatch function, optional
            null, // Redux action to dispatch, optional (should be passed as a function)
            true,  // Flag to toggle between OK and Yes/No
            currentLang?.Buttons?.No, // Optional cancel button text if useConfirmCancel is true
            () => UpdateConnection(selectedrow)
        );
    }

    const UpdateConnection = (selectedrow) => {
        if (selectedrow?.PUIConnectionID) {
            const requestData = {
                puiConnectionID: selectedrow?.PUIConnectionID,
                userID: selectedrow?.PublicUserID,
                inmatesId: selectedrow?.InmateID,
                facilityID: selectedrow?.FacilityID,
                requestChangeUser: "Inmate",
                toConnectionStatusID: 4,
                action: 0,
                isSALoginAsPU: 0,
                inmateResidentID: storedloginResponse?.InmatesResdId,
                relationShip: "",
                inmateInvitePublicUserID: 0
            };
            dispatch(MyContactsActions.loadUpdateInmateConnection(requestData)).then(x => {
                switch (x?.payload) {
                    case 1: setisConnectionCancelled(true);
                        setModalContent(currentLang?.AlertPopup?.Connection_Cancel_Success); setShowPopup(true); setmodalContentColor('#4a9a93');
                        break;
                    case -1:
                        setModalContent(currentLang?.AlertPopup?.Operation_Failed); setShowPopup(true); setmodalContentColor('#c8605e');
                        break;
                    case -2:
                        setModalContent(currentLang?.AlertPopup?.Not_Request_Rejected_By_Inmate); setShowPopup(true); setmodalContentColor('#c8605e');
                        break;
                    case -3:
                        setModalContent(currentLang?.AlertPopup?.Not_Request_Accept_By_Inmate); setShowPopup(true); setmodalContentColor('#c8605e');
                        break;
                    case -4:
                        setModalContent(currentLang?.AlertPopup?.Not_Request_Cancel_By_PU); setShowPopup(true); setmodalContentColor('#c8605e');
                        break;
                    case -5:
                        setModalContent(currentLang?.AlertPopup?.Not_Request_Accept_By_PU); setShowPopup(true); setmodalContentColor('#c8605e');
                        break;
                    case -6:
                        setModalContent(currentLang?.AlertPopup?.The_Inmate_Connection_Limit_Exceeded); setShowPopup(true); setmodalContentColor('#c8605e');
                        break;
                }
            });
        }
    }

    const handleNewmsgConfirmation = (selectedrow) => {
        showAlert(
            null,
            currentLang?.AlertPopup?.Message,
            currentLang?.AlertPopup?.Redirect_Page,
            "question",
            "700px",
            currentLang?.Buttons?.Yes,
            null, // Default redirect URL
            null,  // Redux dispatch function, optional
            null, // Redux action to dispatch, optional (should be passed as a function)
            true,  // Flag to toggle between OK and Yes/No
            currentLang?.Buttons?.No, // Optional cancel button text if useConfirmCancel is true
            () => handleNewChat(selectedrow)
        );
    }

    const handleNewChat = (selectedrow) => {
        setisshowListPage(true);
        const PublicUserEmail = MyContactsDisplayForEcardDetails?.find(
            x => x?.PublicUserID === selectedrow?.PublicUserId
        )?.PublicUserEmail || '0';
        setFormData(prevFormData => ({
            ...prevFormData, activeTab: "Send_E_Card", pageNo: 1, user: PublicUserEmail, isUserdisabled: true
        }));
    }

    const handleLoadFreeCredits = () => {
        dispatch(E_CardActions.InmateMyContactsDisplayForEcard({ InmateID: storedloginResponse?.InmateID, PublicUserID: 0, ConnectionStatus: 2, SortBy: "" }));
        dispatch(inboxActions.LoadInmateFreeCreditBalanceResult({
            inmateResidentID: storedloginResponse?.InmatesResdId,
            facilityId: storedloginResponse?.facilityID,
        })).then((x) => {
            if (x.payload?.length > 0) {
                const { InmateFreeCreditAmount, FreeCreditActiveStatus } = x.payload[0];
                setFormData(prevFormData => ({
                    ...prevFormData,
                    freeCredits: InmateFreeCreditAmount,
                    freeCreditStatus: FreeCreditActiveStatus === 1
                }));
            }
        })
        dispatch(inboxActions.LoadCactasServiceDetailsResult({ facilityId: storedloginResponse?.facilityID })).then((x) => {
            let result = x.payload;
            if (result?.length > 0 && result[0].IsInmateCactasCredit === 1) {
                const { CactasURL, CactasAccessKey, FacilityEmojiCost } = result[0];
                setFormData(prevFormData => ({
                    ...prevFormData,
                    facilityEmojiCost: FacilityEmojiCost
                }));
                // const residentID = storedloginResponse?.InmatesResdId;
                // dispatch(inboxActions.LoadInmateBalance({ cactasURL: CactasURL, cactasAccessKey: CactasAccessKey, residentID: residentID })).then((x) => {
                //     if (x?.payload) {
                //         const balanceValue = parseFloat(x?.payload) || 0;
                //         setFormData(prevFormData => ({
                //             ...prevFormData,
                //             balance: Math.round(balanceValue * 100) / 100
                //         }));
                //     }
                // });
            }
        })
    }

    const renderTab = () => {
        return (
            <div className="tabs-container mb-2">
                <div className="tabs-group">
                    <button title={currentLang?.E_Cards?.E_cards_History}
                        className={`tab-btn ${formData?.activeTab === 'E_Card' ? 'active' : ''}`}
                        onClick={() => {
                            setFormData(prevFormData => ({
                                ...prevFormData, activeTab: "E_Card", search: ""
                            })); setcurrentPage(1);
                            PageOnLoad(1, formData?.rowCountPerPage);
                            handleloadsidemenu();
                        }}
                    >
                        <i className="fas fa-id-card me-2"></i> {currentLang?.E_Cards?.E_cards_History}
                    </button>
                    <button title={currentLang?.E_Cards?.Send_E_Card}
                        className={`tab-btn ${formData?.activeTab === 'Send_E_Card' ? 'active' : ''}`}
                        onClick={() => setFormData(prevFormData => ({
                            ...prevFormData, activeTab: "Send_E_Card", pageNo: 1, subject: "", user: "", isUserdisabled: false, search: ""
                        }))}
                    >
                        <i className="fas fa-paper-plane me-2"></i> {currentLang?.E_Cards?.Send_E_Card}
                    </button>
                </div>
                {(formData?.freeCreditStatus && formData?.activeTab === 'Send_E_Card') && <div className="message-cost">
                    <label className="msg-cost">
                        {currentLang?.Messages?.AVAILABLE_FREE_CREDITS}
                        <span className="cost-value ml-5">
                            $<span id="spnMessageCost">{parseFloat(formData?.freeCredits || 0).toFixed(2)}</span>
                        </span>
                    </label>
                </div>}
                {/* {(LoadECardSearchDetails?.length > 0 && formData?.activeTab === 'E_Card') && <div className="message-cost">
                    <div className="d-flex flex-wrap gap-2 mt-1 me-2">
                        <div className="d-flex flex-wrap align-items-center  me-2">
                            <div className="user-batch button-success me-1"></div>
                            <div className="text fs-5">{currentLang?.E_Cards?.Public_Users}</div>
                        </div>
                        <div className="d-flex flex-wrap align-items-center me-2">
                            <div className="user-batch button-primary me-1"></div>
                            <div className="text fs-5">{currentLang?.E_Cards?.Inmates}</div>
                        </div>
                    </div>
                </div>} */}
                {/* E_Card history code  */}
                {((LoadECardSearchDetails?.length > 0 || formData?.search?.trim()?.length > 0) && formData?.activeTab === 'E_Card') &&

                    <div className="messenger-chat-header d-flex">
                        <div className="flex-1 position-relative margin-10">
                            <input
                                //type="search"
                                className="form-control border-0 bg-light pad-left-30 padding-search"
                                placeholder={currentLang?.Messages?.Search_Placeholder}
                                value={formData?.search}
                                onClick={() => { setShowBoard(true); setisprevsearchvalue(formData?.search) }}
                            />
                            <i className="fa fa-search search-icon"></i>
                        </div>
                    </div>
                }
            </div>
        );
    };

    const handleToggle = () => {
        setMenuActive(!isMenuActive);
    };

    const renderE_CardTab = () => {
        return (
            <>
                {isshowListPage ?
                    (LoadECardSearchDetails?.length > 0 ?
                        <>
                            {/* E_Card history code  */}
                            <div className='row col-12'>
                                <div className="col-8">
                                    <label className="instructNotes">
                                        <i className="fa fa-info-circle no-cursor"></i> {currentLang?.MyContacts?.MyContacts_TableDes}</label>
                                </div>
                                <div className="message-cost col-4">
                                    <div className="d-flex flex-wrap gap-2 mt-1 me-2">
                                        <div className="d-flex flex-wrap align-items-center me-2">
                                            <div className="user-batch button-success me-1"></div>
                                            <div className="text fs-5">{currentLang?.E_Cards?.Public_Users}</div>
                                        </div>
                                        <div className="d-flex flex-wrap align-items-center me-2">
                                            <div className="user-batch button-primary me-1"></div>
                                            <div className="text fs-5">{currentLang?.E_Cards?.Inmates}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Table
                                isScrollContainer={false}
                                columns={columns}
                                data={LoadECardSearchDetails}
                                pagination={true}
                                handleONCLick={handleONCLick}
                                onChangeRowsPerPage={handleonChangeRowsPerPage}
                                onChangePage={handlePageChange}
                                totalRowCount={LoadECardSearchDetails[0]?.TotalEcardCount}
                                currentPage={currentPage}
                                paginationPerPage={rowPerPage}
                                paginationServer={true}
                            />

                        </> : (!loading && <span className="col-no-data">{currentLang?.No_Data_Found}</span>))
                    :

                    <div className="message-container">
                        <div className="row Photosform-grid">
                            <div className="col-lg-3 grid-item mb-1">
                                <p className='mb-0 '>{currentLang?.TableHeaders?.From}</p>
                                <p className="bold-text text-default-red mb-0" >{selectItem?.MessageFrom}</p>
                            </div>
                            <div className="col-lg-5 grid-item mb-1">
                                <p className='mb-0'>{currentLang?.TableHeaders?.Subject}</p>
                                <p className="bold-text text-default-red mb-0 ">{selectItem?.EcardSubject}</p>
                            </div>
                            <div className="col-lg-3 grid-item mb-1">
                                <p className='mb-0'>{currentLang?.TableHeaders?.Date}</p>
                                <p className="bold-text text-default-red mb-0">{formatDate(selectItem.DebitAmountDate)}</p>
                            </div>
                            <div className="col-lg-1 grid-item mb-3" style={{ marginTop: '10px' }}>
                                <img src={!isMenuActive ? quickicon : closeIcon} onClick={handleToggle} ></img>

                            </div>

                        </div>

                        <div className="row col-12">
                            <div className={isMenuActive ? "col-lg-9 " : "col-lg-12"}>
                                <div className="col-sm-12 col-md-12  border-end ">

                                    {selectItem?.Envelopecolor ? <CustomEcard rotation={rotation} setRotation={setRotation}
                                        envelopecolor={selectItem?.Envelopecolor} ecardbgcolor={selectItem?.Ecardbgcolor} rippencolor={selectItem?.Rippencolor}
                                        setenvelopecolor={setenvelopecolor} setecardbgcolor={setecardbgcolor} setrippencolor={setrippencolor}
                                        setLoading={setLoading} imgsrc={imgsrc} customized={customized} setCustomized={setCustomized} />
                                        :
                                        <CustomPhoto rotation={rotation} setRotation={setRotation}
                                            envelopecolor={selectItem?.Envelopecolor} ecardbgcolor={selectItem?.Ecardbgcolor} rippencolor={selectItem?.Rippencolor}
                                            setenvelopecolor={setenvelopecolor} setecardbgcolor={setecardbgcolor} setrippencolor={setrippencolor}
                                            setLoading={setLoading} imgsrc={imgsrc} customized={customized} setCustomized={setCustomized} />}
                                    <p className="textnote">
                                        <i>{currentLang?.Messages?.Textnote}</i>
                                    </p>
                                </div>
                            </div>
                            {isMenuActive &&
                                <div className="col-sm-12 col-md-12 col-lg-3 border-end ">
                                    <div className="cl-left-menu-message">
                                        <div className="messenger-content">
                                            <div className="widget-chat">
                                                <div className="available-credits-section flex-wrap ">
                                                    <div className="cost-item d-flex align-items-center">
                                                        <h5 title="Message Cost" className="me-2 fw-bold mt-2">
                                                            {currentLang?.Messages?.AVAILABLE_FREE_CREDITS}
                                                            <span className="noWrap class-balance ml-5 cost-value">
                                                                $<span id="spnMessageCost">{parseFloat(formData?.freeCredits || 0).toFixed(2)}</span>
                                                            </span>
                                                        </h5>
                                                    </div>
                                                </div>
                                                <ul className="submenu-list">
                                                    <li onClick={() => {
                                                        if (selectItem?.ConnectionStatusID !== 4 && selectItem?.ConnectionStatusID !== 3 && selectItem?.ConnectionStatusID !== 5 && !isConnectionCancelled) {
                                                            handleNewmsgConfirmation(selectItem);
                                                        }
                                                    }} className={`ActiveSubmenu ActiveNewMail ${(selectItem?.ConnectionStatusID === 3 || selectItem?.ConnectionStatusID === 5 || selectItem?.ConnectionStatusID === 4 || isConnectionCancelled) ? "nocursor" : ""}`}
                                                        title={currentLang?.E_Cards?.New_E_Cards}>{currentLang?.E_Cards?.New_E_Cards}
                                                        <label className="pointer float-end"><i className="fa fa-envelope"></i></label></li>

                                                    <li onClick={() => {
                                                        if (selectItem?.ConnectionStatusID !== 4 && selectItem?.ConnectionStatusID !== 5 && selectItem?.ConnectionStatusID !== 3 && !isConnectionCancelled) {
                                                            UpdateConnectionConfiramation(selectItem);
                                                        }
                                                    }}
                                                        className={`ActiveSubmenu ${(selectItem?.ConnectionStatusID === 4 || selectItem?.ConnectionStatusID === 5 || selectItem?.ConnectionStatusID === 3 || isConnectionCancelled) ? "nocursor" : ""}`} title={currentLang?.Messages?.Cancel_Connection}>
                                                        {currentLang?.Messages?.Cancel_Connection}<label className="pointer float-end"><i className="fa fa-times-circle"></i></label>
                                                    </li>
                                                    {/* E_Card history code  */}
                                                    <li className="liMailHistory ActiveSubmenu" title={currentLang?.E_Cards?.E_cards_History} onClick={() => {
                                                        setisshowListPage(true); setcurrentPage(1);
                                                        handleSeach(selectItem?.Sender == "Inmate" ? selectItem?.MessageTo : selectItem?.MessageFrom, 1)
                                                    }}>{currentLang?.E_Cards?.E_cards_History} <label className="pointer float-end"><i className="fa fa-archive"></i></label></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }
            </>
        );
    }


    const onInputChange = (value) => {
        setFormData(prevFormData => ({
            ...prevFormData, search: value,
        }));
    }

    const handleKeyPress = (event) => {
        handleSeach(formData?.search);
    }

    const handleSeach = (value, page = 1) => {
        setFormData(prevFormData => ({
            ...prevFormData, search: value,
        }));
        setLoading(true);
        var Objectdata = {
            publicUserID: 0, sortField: "", ecardSubject: '', fromDate: '', toDate: '', status: 0,
            pageNo: page ? page : currentPage, rowCountPerPage: rowPerPage, inmateID: storedloginResponse?.InmateID, MessageFrom: value
        };
        dispatch(E_CardActions.getLoadE_CardList(Objectdata)).then(x => {
            setLoadECardSearchDetails(x?.payload || []);
            setLoading(false);
        });
    }

    return (
        <div className="dashboard-container">
            <div className="dashboard-content">
                <div className="d-flex justify-content-between mb-1 pt-1">
                    <div className="align-self-start">
                        <div className="icon-container">
                            <h3 className="find-inmate-head">{currentLang?.E_Card}</h3>
                        </div>
                    </div>
                    {!isshowListPage && <div className="align-self-end">
                        <Button
                            className='btn-danger'
                            label={currentLang?.Buttons?.Back}
                            type="button"
                            status="back"
                            onClick={() => {
                                handleBack();
                            }}
                        />
                    </div>}
                </div>

                <div className="divider mb-3"></div>

                <div className="card-default">
                    <ScrollContainer isSendECard={formData?.activeTab === "Send_E_Card" ? true : false} >
                        {isshowListPage && renderTab()}
                        {formData?.activeTab === "E_Card" && renderE_CardTab()}
                        {formData?.activeTab === "Send_E_Card" &&
                            <Send_E_Card rotation={rotation} setRotation={setRotation} setLoading={setLoading}
                                formData={formData} setFormData={setFormData} isshowListPage={isshowListPage} setisshowListPage={setisshowListPage} />
                        }
                    </ScrollContainer>
                </div>
                {loading && <Loader />}
            </div>
            {showBoard &&
                <CustomKeyboard
                    onInputChange={onInputChange}
                    inputValue={formData?.search}
                    onKeyPress={handleKeyPress}
                    handleCancel={() => {
                        handleSeach(isprevsearchvalue);
                        setShowBoard(false); setFormData(prevFormData => ({
                            ...prevFormData,
                            search: isprevsearchvalue
                        }));
                    }}
                    setShowBoard={setShowBoard}
                    placeholder={currentLang?.Messages?.Search_Placeholder}
                    isECard={true}
                />
            }
            {showPopup && (
                <CustomModal
                    color={modalContentColor}
                    content={modalContent}
                    onOkClick={() => { setShowPopup(false); setRotation(0); }}
                />
            )}
        </div>
    );
};

export default memo(E_Card);

